export default {
  DB_OPENED (state) {
    state.db = true
  },

  SET_LOGIN_VIS (state, bool) {
    state.showLogin = bool
  },
  LOGOUT (state) {
    state.showLogin = false
    state.appCredentials = false
    state.userInfo = false
    state.mynotes = []
  },

  SET_APP_CREDENTIALS (state, credentials) {
    state.appCredentials = credentials
  },

  SET_USER_INFO (state, info) {
    state.userInfo = info
  },

  ADD_UPLOAD (state, draftKey) {
    state.uploadQueue.push(draftKey)
  },
  QUEUE_STATUS (state, bool) {
    state.processingQueue = bool
  },
  SHIFT_QUEUE (state) {
    state.uploadQueue.shift()
  },

  ADD_MY_NOTE (state, note) {
    state.mynotes.unshift(note)
  },

  ADD_RECORDING (state, file) {
    state.recording = file
  },

  DELETE_RECORDING (state) {
    state.recording = null
  },

  ADD_MP3 (state, file) {
    state.mp3 = file
  },

  ADD_DRAFT (state, draft) {
    let existing = state.drafts.findIndex(d => d.draftKey === draft.draftKey)
    if (existing > -1) {
      state.drafts.splice(existing, 1, draft)
      return
    }
    state.drafts.unshift(draft)
  },

  DELETE_DRAFT (state, key) {
    const index = state.drafts.findIndex(f => f.draftKey === key)
    state.drafts.splice(index, 1)
  },

  DELETE_NOTE (state, id) {
    const notesIndex = state.notes.findIndex(f => f.id === id)
    if (notesIndex !== -1) {
      state.notes.splice(notesIndex, 1)
    }

    const mynotesIndex = state.mynotes.findIndex(f => f.id === id)
    if (mynotesIndex !== -1) {
      state.mynotes.splice(mynotesIndex, 1)
    }

    const nearbynotesIndex = state.nearbynotes.findIndex(f => f.id === id)
    if (nearbynotesIndex !== -1) {
      state.nearbynotes.splice(nearbynotesIndex, 1)
    }
  },

  SET_LOADING (state, payload) {
    state.loading = payload
  },

  SET_SHOW_ADD_TO_HOMESCREEN (state, payload) {
    state.showAddToHomeScreen = payload
  },

  FLAG_PROMPTED_TO_ADD_PWA (state, payload) {
    state.promptedToAddPwa = payload;
  },

  UPDATE_LATEST_NOTES (state, payload) {
    state.notes = payload
  },

  INCREMENT_CURRENT_PAGE (state) {
    state.current_page = state.current_page + 1
  },

  UPDATE_TOTAL_PAGES (state, payload) {
    state.total_pages = parseInt(payload)
  },

  APPEND_LATEST_NOTES (state, payload) {
    state.notes = state.notes.concat(payload)
  },

  UPDATE_NEARBY_NOTES (state, payload) {
    state.nearbynotes = payload
  },

  APPEND_NEARBY_NOTES (state, payload) {
    state.nearbynotes = state.nearbynotes.concat(payload)
  },

  UPDATE_MY_NOTES (state, payload) {
    state.mynotes = payload
  },

  APPEND_MY_NOTES (state, payload) {
    state.mynotes = state.mynotes.concat(payload)
  },

  TRUNCATE_ALL_NOTES (state, payload) {
    state.notes = state.notes.slice(0, payload)
    state.nearbynotes = state.nearbynotes.slice(0, payload)
    state.mynotes = state.mynotes.slice(0, payload)
  },

  UPDATE_LOCATION (state, location) {
    state.location = location
  },

  SET_BANNER (state, { show, text }) {
    state.bannerStatus.show = show
    if (text !== undefined) {
      state.bannerStatus.text = text
    }
  }
}
